import {
  addObj,
  getAll,
  deleteObj,
  searchByName,
  modifyObj,
  getDetail,
  getPage,
} from '@/api/saleschannelserv'

export default {
  state: {
    state_SalesChannel_AddObjResult: null,
    state_SalesChannel_GetAllResult: null,
    state_SalesChannel_DeleteObjResult: null,
    state_SalesChannel_SearchByNameResult: null,
    state_SalesChannel_ModifyObjResult: null,
    state_SalesChannel_GetDetailResult: null,
    state_SalesChannel_GetPageResult: null,
  },
  mutations: {
    SET_SALESCHANNEL_ADDOBJ_RESULT: (state, rst) => {
      state.state_SalesChannel_AddObjResult = rst;
    },
    SET_SALESCHANNEL_GETALL_RESULT: (state, rst) => {
      state.state_SalesChannel_GetAllResult = rst;
    },
    SET_SALESCHANNEL_DELETEOBJ_RESULT: (state, rst) => {
      state.state_SalesChannel_DeleteObjResult = rst;
    },
    SET_SALESCHANNEL_SEARCHBYNAME_RESULT: (state, rst) => {
      state.state_SalesChannel_SearchByNameResult = rst;
    },
    SET_SALESCHANNEL_MODIFYOBJ_RESULT: (state, rst) => {
      state.state_SalesChannel_ModifyObjResult = rst;
    },
    SET_SALESCHANNEL_GETDETAIL_RESULT: (state, rst) => {
      state.state_SalesChannel_GetDetailResult = rst;
    },
    SET_SALESCHANNEL_GETPAGE_RESULT: (state, rst) => {
      state.state_SalesChannel_GetPageResult = rst;
    },
  },
  actions: {
    SalesChannelServ_AddObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        addObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_SALESCHANNEL_ADDOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_SALESCHANNEL_ADDOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    SalesChannelServ_GetAll({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getAll(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_SALESCHANNEL_GETALL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_SALESCHANNEL_GETALL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    SalesChannelServ_DeleteObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        deleteObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_SALESCHANNEL_DELETEOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_SALESCHANNEL_DELETEOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    SalesChannelServ_SearchByName({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        searchByName(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_SALESCHANNEL_SEARCHBYNAME_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_SALESCHANNEL_SEARCHBYNAME_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    SalesChannelServ_ModifyObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        modifyObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_SALESCHANNEL_MODIFYOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_SALESCHANNEL_MODIFYOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    SalesChannelServ_GetDetail({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_SALESCHANNEL_GETDETAIL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_SALESCHANNEL_GETDETAIL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    SalesChannelServ_GetPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_SALESCHANNEL_GETPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_SALESCHANNEL_GETPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_SalesChannel_AddObjResult: state => {
      return state.state_SalesChannel_AddObjResult;
    },
    get_SalesChannel_GetAllResult: state => {
      return state.state_SalesChannel_GetAllResult;
    },
    get_SalesChannel_DeleteObjResult: state => {
      return state.state_SalesChannel_DeleteObjResult;
    },
    get_SalesChannel_SearchByNameResult: state => {
      return state.state_SalesChannel_SearchByNameResult;
    },
    get_SalesChannel_ModifyObjResult: state => {
      return state.state_SalesChannel_ModifyObjResult;
    },
    get_SalesChannel_GetDetailResult: state => {
      return state.state_SalesChannel_GetDetailResult;
    },
    get_SalesChannel_GetPageResult: state => {
      return state.state_SalesChannel_GetPageResult;
    },
  }
}